import {appRouter} from '@netx/core-next/instance/router';
import {favoriteSavedCarts} from '@netx/core-cart/singletons/savedCarts';
import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {dispatcher} from '@netx/core-next/instance/dispatcher';

//////////////////////////
// Underscore mixins
//////////////////////////
_.mixin({
	overrideDefaultIcon(path, override) {
		if (!path || (!path.includes('icons/') && !override)) return '';
		return (
			'custom-icon-' +
			_.toCamelCase(path.replace(/^\S+icons\//, '').replace(/\.\S+$/, ''))
		);
	},
});
//////////////////////////
// !Underscore mixins
//////////////////////////

//////////////////////////
// Event Listeners
//////////////////////////
// /**
//  * A catch all listener
//  * @event all
//  */
// dispatcher.on('all', function(eventName) {
// 	console.debug('>>EVENT ' + eventName);
// } );

// Sidebar tab custom events

/** @event module:nx#nx:home */
dispatcher.on('nx:home', function () {
	appRouter.home();
});

dispatcher.on('nx:collections', function () {
	favoriteSavedCarts.fetch();
});

/** @event module:nx#nx:notifications */
dispatcher.on('nx:notifications', function () {
	appRouter.navigate('notifications', {trigger: true});
});

//////////////////////////
// !Event Listeners
//////////////////////////

/**
 * @event netx:app:modules
 * @fires module:netx#netx:load:module
 * @fires module:app#app:ready
 */
dispatcher.once('netx:app:modules', () => {
	// This is the pattern for defining all modules that must load as part of your app
	// after the user is validated
	// Keep in mind we still have some global variable tangles and some modules have
	// to be defined before others
	Promise.all([
		import(/* webpackChunkName: "post-login-app" */ '@netx/core-cart'),
		import(/* webpackChunkName: "post-login-app" */ '@netx/core-category'),
		import(/* webpackChunkName: "post-login-app" */ '@netx/core-dashboard'),
		import(/* webpackChunkName: "post-login-app" */ '@netx/core-grid'),
		import(/* webpackChunkName: "post-login-app" */ '@netx/core-share'),
		import(/* webpackChunkName: "post-login-app" */ '@netx/core-user'),
	]).then((modules) => {
		dispatcher.trigger(
			'netx:load:module',
			modules.map((m) => m.default),
			{
				initialized() {
					// Load any modules that are conditional (and cannot be deferred for later)
					const promises = [];

					if (getPreference('review.enabled', true)) {
						promises.push(
							new Promise((resolve, reject) => {
								import(
									/* webpackChunkName: "project" */ '@netx/core-project'
								).then((Project) => {
									dispatcher.trigger('netx:load:module', Project.default, {
										initialized: resolve,
									});
								});
							}),
						);
					}

					// Consumers or above (bulk selection uploader)
					if (currentUserMeetsUserLevel(UserLevel.CONSUMER)) {
						promises.push(
							new Promise((resolve, reject) => {
								import(
									/* webpackChunkName: "upload" */ '@netx/core-upload'
								).then((Upload) => {
									dispatcher.trigger('netx:load:module', Upload.default, {
										initialized: resolve,
									});
								});
							}),
						);
					}

					// Always dispatch `app:ready` when done
					Promise.all(promises).then(() => {
						dispatcher.trigger('app:ready', true);
					});
				},
			},
		);
	});
});

//////////////////////////
// NetX Ready
//////////////////////////
/**
 * Custom events and functions should be utilized within the "ready" event
 * @event module:app#app:ready
 */
dispatcher.once('app:ready', function () {
	/**
	 * Build UI
	 *
	 * This is the entry point for building your application UI.
	 * Place all custom code below this comment block.
	 */
	// Custom Code Here
});
//////////////////////////
// !NetX Ready
//////////////////////////
